var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-tabs", {
    attrs: {
      "full-control": _vm.fullControl,
      tabs: _vm.tabs,
      value: _vm.value,
      "show-advanced-settings": "",
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }